import r from "lodash/merge";
import n from "lodash/debounce";
import i from "lodash/get";
import { Hub as s } from "aws-amplify/utils";
class d extends Error {
  constructor() {
    super("No current user");
  }
}
function u(t, e) {
  s.dispatch("toast", {
    event: "error",
    message: t,
    data: {
      title: e.title,
      timeout: e.noAutoHide ? 0 : 1e4
    }
  });
}
function c() {
  n(
    () => s.dispatch("toast", {
      event: "info",
      message: "You need to sign in to access this page",
      data: {
        title: "Authentication Error",
        timeout: 5e3
      }
    }),
    5e3
  );
}
function p(t) {
  s.dispatch("authCustom", {
    event: "doLogout",
    data: {
      reason: t
    }
  }), c();
}
function f(t) {
  const e = {
    message: i(t, "message", "An error occurred"),
    data: {}
  };
  if (t.response) {
    if (t.response.data)
      e.data = t.response.data;
    else if (t.response.body)
      try {
        e.data = JSON.parse(t.response.body);
      } catch {
        console.warn("Failed to parse api error response body, ignoring");
      }
    e.data.detail && (e.message = e.data.detail);
  }
  return e;
}
function E(t, e) {
  if (t instanceof d || t === "No current user")
    return p(t);
  const a = r(
    {},
    {
      noAutoHide: !0,
      title: "Api Error"
    },
    {}
  ), o = f(t);
  return o.data.title && (a.title = `${t.response.statusCode} ${o.data.title}`), console.error(t), u(o.message, a);
}
export {
  d as N,
  E as e,
  f as p
};
